import { MetadataEntry } from '../types/MetadataEntry';
import { parseJsonMetadata } from './jsonMetadata';

function summarizeEntry(entry: MetadataEntry): string {
  if (entry.kind === 'value') {
    const value = entry.scalarValue?.trim();
    if (!value) {
      return '—';
    }
    if (entry.valueKind === 'boolean') {
      return value === 'true' ? 'Sim' : 'Não';
    }
    return value.length > 40 ? `${value.slice(0, 40)}…` : value;
  }

  if (entry.kind === 'list') {
    if (entry.listItemKind === 'object') {
      return `${entry.listObjects?.length ?? 0} grupo(s)`;
    }
    const count = (entry.listItems ?? []).filter((item) => item.trim()).length;
    return `${count} item(ns)`;
  }

  return `${entry.children?.length ?? 0} campo(s)`;
}

export function buildMetadataPreview(json?: string | null, limit = 3): string[] {
  const entries = parseJsonMetadata(json);
  return entries
    .filter((entry) => entry.key.trim())
    .slice(0, limit)
    .map((entry) => `${entry.key}: ${summarizeEntry(entry)}`);
}

export function countMetadataFields(json?: string | null): number {
  return parseJsonMetadata(json).filter((entry) => entry.key.trim()).length;
}
